export enum LoggerContext {
  Archive = 'archive',
  Auth = 'auth',
  Claims = 'claims',
  GlobalError = 'global-error',
  History = 'history',
  Lienholder = 'lienholder',
  RequestTracking = 'request-tracking',
  Router = 'router',
  UserStore = 'user-store',
}
